/* =========================================================
   SHOPIFY AJAX CART + CART DRAWER RECOMMENDATIONS
   ========================================================= */

document.addEventListener('DOMContentLoaded', function () {

  /*
   * =======================================================
   * GLOBAL SETTINGS
   * =======================================================
   */

  let recommendationLoading = false;


  /*
   * =======================================================
   * QUANTITY + / -
   * =======================================================
   */

  document.addEventListener('click', function (event) {

    const minusBtn =
      event.target.closest('.card-qty-minus');

    const plusBtn =
      event.target.closest('.card-qty-plus');

    if (!minusBtn && !plusBtn) {
      return;
    }


    const selector =
      event.target.closest('.card-quantity-selector');

    if (!selector) {
      return;
    }


    const input =
      selector.querySelector('.card-qty-input');

    if (!input) {
      return;
    }


    let quantity =
      parseInt(input.value, 10) || 1;


    if (minusBtn) {

      quantity =
        Math.max(1, quantity - 1);

    }


    if (plusBtn) {

      quantity++;

    }


    input.value =
      quantity;

  });


  /*
   * =======================================================
   * MAIN PRODUCT / PRODUCT CARD AJAX ADD TO CART
   * =======================================================
   *
   * Handles:
   * .ajax-card-product-form
   * .custom-product-form
   *
   * =======================================================
   */

  document.addEventListener(
    'submit',
    async function (event) {

      const form =
        event.target.closest(
          '.ajax-card-product-form, .custom-product-form'
        );


      if (!form) {
        return;
      }


      /*
       * Stop normal Shopify submit
       */

      event.preventDefault();
      event.stopImmediatePropagation();


      /*
       * Prevent duplicate request
       */

      if (
        form.dataset.ajaxSubmitting === 'true'
      ) {
        return;
      }


      form.dataset.ajaxSubmitting =
        'true';


      /*
       * =====================================================
       * FIND BUTTON
       * =====================================================
       */

      const button =
        form.querySelector('.ajax-card-add') ||
        form.querySelector('.add-to-cart') ||
        form.querySelector('[name="add"]');


      /*
       * =====================================================
       * TEXT ELEMENTS
       * =====================================================
       */

      const addText =
        form.querySelector(
          '.product-card-add-text'
        );


      const loadingText =
        form.querySelector(
          '.product-card-add-loading'
        );


      /*
       * =====================================================
       * VARIANT ID
       * =====================================================
       */

      const variantInput =
        form.querySelector(
          '.product-card-variant-id'
        ) ||
        form.querySelector(
          'input[name="id"]'
        );


      /*
       * =====================================================
       * QUANTITY
       * =====================================================
       */

      const quantityInput =
        form.querySelector(
          '.card-qty-input'
        ) ||
        form.querySelector(
          'input[name="quantity"]'
        );


      /*
       * =====================================================
       * CHECK VARIANT
       * =====================================================
       */

      if (
        !variantInput ||
        !variantInput.value
      ) {

        console.error(
          '[AJAX Cart] Variant ID missing'
        );


        form.dataset.ajaxSubmitting =
          'false';


        return;
      }


      const variantId =
        Number(
          variantInput.value
        );


      const quantity =
        parseInt(
          quantityInput?.value,
          10
        ) || 1;


      /*
       * =====================================================
       * LOADING STATE
       * =====================================================
       */

      if (button) {

        button.disabled =
          true;

        button.classList.add(
          'loading'
        );

      }


      if (addText) {

        addText.hidden =
          true;

      }


      if (loadingText) {

        loadingText.hidden =
          false;

      }


      try {


        /*
         * ===================================================
         * ADD PRODUCT TO CART
         * ===================================================
         */

        const response =
          await fetch(
            window.Shopify.routes.root +
            'cart/add.js',
            {

              method:
                'POST',

              headers: {

                'Accept':
                  'application/json',

                'Content-Type':
                  'application/json'

              },

              body:
                JSON.stringify({

                  items: [

                    {

                      id:
                        variantId,

                      quantity:
                        quantity

                    }

                  ]

                })

            }
          );


        const cartItem =
          await response.json();


        /*
         * ===================================================
         * ERROR
         * ===================================================
         */

        if (!response.ok) {

          throw new Error(

            cartItem.description ||
            'Unable to add product to cart'

          );

        }


        console.log(
          '[AJAX Cart] Product added:',
          cartItem
        );


        /*
         * ===================================================
         * GET UPDATED CART DRAWER + CART ICON
         * ===================================================
         */

        const sectionsResponse =
          await fetch(

            window.Shopify.routes.root +
            '?sections=cart-drawer,cart-icon-bubble',

            {

              method:
                'GET',

              headers: {

                'Accept':
                  'application/json'

              },

              cache:
                'no-store'

            }

          );


        if (!sectionsResponse.ok) {

          throw new Error(
            'Unable to refresh cart drawer'
          );

        }


        const sections =
          await sectionsResponse.json();


        /*
         * ===================================================
         * UPDATE CART DRAWER
         * ===================================================
         */

        const cartDrawer =
          document.querySelector(
            'cart-drawer'
          );


        if (
          cartDrawer &&
          sections['cart-drawer']
        ) {


          const parser =
            new DOMParser();


          const newDrawer =
            parser.parseFromString(

              sections['cart-drawer'],

              'text/html'

            ).querySelector(
              'cart-drawer'
            );


          if (newDrawer) {


            /*
             * Keep existing cart-drawer element
             * and replace its contents.
             */

            cartDrawer.innerHTML =
              newDrawer.innerHTML;


            /*
             * Remove empty state
             */

            cartDrawer.classList.remove(
              'is-empty'
            );


            /*
             * =================================================
             * OPEN DRAWER
             * =================================================
             */

            if (
              typeof cartDrawer.open ===
              'function'
            ) {

              cartDrawer.open();

            } else {

              cartDrawer.classList.add(
                'active'
              );

              cartDrawer.setAttribute(
                'open',
                ''
              );

            }


            /*
             * =================================================
             * LOAD RECOMMENDATIONS
             * =================================================
             *
             * IMPORTANT:
             * The drawer HTML was replaced above,
             * therefore the recommendation container
             * is now a new DOM element.
             *
             * =================================================
             */

            setTimeout(
              function () {

                if (
                  typeof window.loadCartDrawerRecommendations ===
                  'function'
                ) {

                  window.loadCartDrawerRecommendations();

                }

              },
              150
            );

          }

        }


        /*
         * ===================================================
         * UPDATE CART ICON
         * ===================================================
         */

        const cartIcon =
          document.querySelector(
            '#cart-icon-bubble'
          );


        if (
          cartIcon &&
          sections['cart-icon-bubble']
        ) {


          const parser =
            new DOMParser();


          const newIcon =
            parser.parseFromString(

              sections[
                'cart-icon-bubble'
              ],

              'text/html'

            ).querySelector(
              '#cart-icon-bubble'
            );


          if (newIcon) {

            cartIcon.innerHTML =
              newIcon.innerHTML;

          }

        }


        /*
         * ===================================================
         * RESET QUANTITY
         * ===================================================
         */

        if (quantityInput) {

          quantityInput.value =
            1;

        }


      } catch (error) {


        console.error(
          '[AJAX Cart] ERROR:',
          error
        );


        alert(
          error.message ||
          'Unable to add product to cart.'
        );


      } finally {


        /*
         * ===================================================
         * REMOVE LOADING
         * ===================================================
         */

        if (button) {

          button.disabled =
            false;

          button.classList.remove(
            'loading'
          );

        }


        if (addText) {

          addText.hidden =
            false;

        }


        if (loadingText) {

          loadingText.hidden =
            true;

        }


        form.dataset.ajaxSubmitting =
          'false';

      }

    }
  );


  /*
   * =======================================================
   * CART DRAWER RECOMMENDATIONS
   * =======================================================
   */

  async function loadCartDrawerRecommendations() {


    const container =
      document.querySelector(
        '#CartDrawerRecommendationProducts'
      );


    if (!container) {

      console.log(
        '[Cart Recommendations] Container not found'
      );

      return;

    }


    if (recommendationLoading) {

      return;

    }


    recommendationLoading =
      true;


    try {


      /*
       * ===================================================
       * GET CURRENT CART
       * ===================================================
       */

      const cartResponse =
        await fetch(

          window.Shopify.routes.root +
          'cart.js',

          {

            method:
              'GET',

            headers: {

              'Accept':
                'application/json'

            },

            cache:
              'no-store'

          }

        );


      if (!cartResponse.ok) {

        throw new Error(
          'Unable to get cart'
        );

      }


      const cart =
        await cartResponse.json();


      console.log(
        '[Cart Recommendations] Cart:',
        cart
      );


      /*
       * ===================================================
       * EMPTY CART
       * ===================================================
       */

      if (
        !cart.items ||
        cart.items.length === 0
      ) {

        container.innerHTML =
          '';

        recommendationLoading =
          false;

        return;

      }


      /*
       * ===================================================
       * CURRENT PRODUCT
       * ===================================================
       */

      const productId =
        cart.items[0].product_id;


      if (!productId) {

        container.innerHTML =
          '';

        recommendationLoading =
          false;

        return;

      }


      /*
       * ===================================================
       * RECOMMENDATION API
       * ===================================================
       */

      const recommendationURL =

        window.Shopify.routes.root +

        'recommendations/products.json' +

        '?product_id=' +

        encodeURIComponent(
          productId
        ) +

        '&limit=4';


      console.log(
        '[Cart Recommendations] URL:',
        recommendationURL
      );


      const recommendationResponse =
        await fetch(

          recommendationURL,

          {

            method:
              'GET',

            headers: {

              'Accept':
                'application/json'

            },

            cache:
              'no-store'

          }

        );


      if (!recommendationResponse.ok) {

        throw new Error(
          'Recommendation API failed: ' +
          recommendationResponse.status
        );

      }


      const data =
        await recommendationResponse.json();


      console.log(
        '[Cart Recommendations] API:',
        data
      );


      /*
       * ===================================================
       * NO RECOMMENDATIONS
       * ===================================================
       */

      if (
        !data.products ||
        data.products.length === 0
      ) {

        container.innerHTML =
          '';

        recommendationLoading =
          false;

        return;

      }


      /*
       * ===================================================
       * PRODUCTS ALREADY IN CART
       * ===================================================
       */

      const cartProductIds =
        cart.items.map(
          function (item) {

            return Number(
              item.product_id
            );

          }
        );


      /*
       * ===================================================
       * FILTER PRODUCTS ALREADY IN CART
       * ===================================================
       */

      const products =
        data.products.filter(
          function (product) {

            return !cartProductIds.includes(
              Number(product.id)
            );

          }
        );


      if (products.length === 0) {

        container.innerHTML =
          '';

        recommendationLoading =
          false;

        return;

      }


      /*
       * ===================================================
       * CLEAR OLD PRODUCTS
       * ===================================================
       */

      container.innerHTML =
        '';


      /*
       * ===================================================
       * CREATE RECOMMENDATION CARDS
       * ===================================================
       */

      products.forEach(
        function (product) {


          /*
           * -------------------------------------------------
           * SELECT ONLY ONE VARIANT
           * -------------------------------------------------
           */

          let variant =
            null;


          if (
            product.variants &&
            product.variants.length
          ) {


            /*
             * First/default variant
             */

            variant =
              product.variants[0];


            /*
             * If first variant unavailable,
             * use first available variant.
             */

            if (
              variant &&
              !variant.available
            ) {

              const availableVariant =
                product.variants.find(
                  function (item) {

                    return item.available;

                  }
                );


              if (availableVariant) {

                variant =
                  availableVariant;

              }

            }

          }


          /*
           * No variant
           */

          if (!variant) {

            return;

          }


          /*
           * -------------------------------------------------
           * VARIANT PRICE ONLY
           * -------------------------------------------------
           */

          const variantPrice =
            Number(
              variant.price || 0
            );


          const variantComparePrice =
            Number(
              variant.compare_at_price || 0
            );


          /*
           * -------------------------------------------------
           * IMAGE
           * -------------------------------------------------
           */

          let imageURL =
            product.featured_image;


          if (
            !imageURL &&
            product.images &&
            product.images.length
          ) {

            imageURL =
              product.images[0];

          }


          /*
           * -------------------------------------------------
           * PRODUCT URL
           * -------------------------------------------------
           */

          const productURL =
            product.url ||

            (
              window.Shopify.routes.root +
              'products/' +
              product.handle
            );


          /*
           * -------------------------------------------------
           * TITLE
           * -------------------------------------------------
           */

          const title =
            escapeHTML(
              product.title
            );


          /*
           * -------------------------------------------------
           * PRICE HTML
           * -------------------------------------------------
           */

          let priceHTML =
            '';


          if (variantPrice > 0) {


            priceHTML = `

              <span
                class="cart-recommendation-current-price"
              >
                ${formatMoney(variantPrice)}
              </span>

              ${
                variantComparePrice >
                variantPrice

                  ? `

                    <span
                      class="cart-recommendation-compare"
                    >
                      ${formatMoney(
                        variantComparePrice
                      )}
                    </span>

                  `

                  : ''

              }

            `;

          }


          /*
           * -------------------------------------------------
           * ADD BUTTON
           * -------------------------------------------------
           */

          let buttonHTML =
            '';


          if (variant.available) {

            buttonHTML = `

              <button
                type="button"
                class="cart-recommendation-add"
                data-variant-id="${variant.id}"
                data-product-id="${product.id}"
              >
                Add
              </button>

            `;

          } else {

            buttonHTML = `

              <span
                class="cart-recommendation-soldout"
              >
                Sold out
              </span>

            `;

          }


          /*
           * -------------------------------------------------
           * CARD
           * -------------------------------------------------
           */

          const item =
            document.createElement(
              'div'
            );


          item.className =
            'cart-recommendation-item cart-recommendation-slide';


          item.innerHTML = `

            <a
              href="${productURL}"
              class="cart-recommendation-image"
            >

              ${
                imageURL

                  ? `

                    <img
                      src="${imageURL}"
                      alt="${title}"
                      loading="lazy"
                    >

                  `

                  : ''

              }

            </a>


            <div
              class="cart-recommendation-info"
            >

              <a
                href="${productURL}"
                class="cart-recommendation-title"
              >
                ${title}
              </a>


              <div
                class="cart-recommendation-price"
              >

                ${priceHTML}

              </div>


              ${buttonHTML}

            </div>

          `;


          container.appendChild(
            item
          );

        }
      );


      /*
       * ===================================================
       * SLIDER
       * ===================================================
       */

      initializeRecommendationSlider();


    } catch (error) {


      console.error(
        '[Cart Recommendations] ERROR:',
        error
      );


      if (container) {

        container.innerHTML =
          '';

      }


    } finally {

      recommendationLoading =
        false;

    }

  }


  /*
   * =======================================================
   * RECOMMENDATION PRODUCT AJAX ADD
   * =======================================================
   */

  async function addRecommendationToCart(
    button,
    variantId
  ) {


    if (!variantId) {

      return;

    }


    if (
      button.dataset.loading ===
      'true'
    ) {

      return;

    }


    button.dataset.loading =
      'true';


    const originalText =
      button.textContent;


    button.disabled =
      true;


    button.textContent =
      'Adding...';


    try {


      /*
       * ===================================================
       * ADD RECOMMENDATION VARIANT
       * ===================================================
       */

      const response =
        await fetch(

          window.Shopify.routes.root +
          'cart/add.js',

          {

            method:
              'POST',

            headers: {

              'Content-Type':
                'application/json',

              'Accept':
                'application/json'

            },

            body:
              JSON.stringify({

                items: [

                  {

                    id:
                      Number(variantId),

                    quantity:
                      1

                  }

                ]

              })

          }

        );


      if (!response.ok) {


        let message =
          'Unable to add product';


        try {

          const errorData =
            await response.json();


          if (
            errorData.description
          ) {

            message =
              errorData.description;

          }

        } catch (error) {}


        throw new Error(
          message
        );

      }


      /*
       * ===================================================
       * SUCCESS
       * ===================================================
       */

      button.textContent =
        'Added';


      /*
       * ===================================================
       * REFRESH DRAWER
       * ===================================================
       */

      await refreshCartDrawer();


    } catch (error) {


      console.error(
        '[Cart Recommendations] Add ERROR:',
        error
      );


      button.disabled =
        false;


      button.dataset.loading =
        'false';


      button.textContent =
        originalText ||
        'Add';

    }

  }


  /*
   * =======================================================
   * REFRESH CART DRAWER
   * =======================================================
   */

  async function refreshCartDrawer() {

    try {


      const response =
        await fetch(

          window.Shopify.routes.root +
          '?sections=cart-drawer,cart-icon-bubble',

          {

            method:
              'GET',

            headers: {

              'Accept':
                'application/json'

            },

            cache:
              'no-store'

          }

        );


      if (!response.ok) {

        throw new Error(
          'Cart drawer refresh failed'
        );

      }


      const sections =
        await response.json();


      /*
       * ===================================================
       * CART DRAWER
       * ===================================================
       */

      const cartDrawer =
        document.querySelector(
          'cart-drawer'
        );


      if (
        cartDrawer &&
        sections['cart-drawer']
      ) {


        const parser =
          new DOMParser();


        const newDrawer =
          parser.parseFromString(

            sections['cart-drawer'],

            'text/html'

          ).querySelector(
            'cart-drawer'
          );


        if (newDrawer) {


          cartDrawer.innerHTML =
            newDrawer.innerHTML;


          cartDrawer.classList.remove(
            'is-empty'
          );


          /*
           * Keep drawer open
           */

          if (
            typeof cartDrawer.open ===
            'function'
          ) {

            cartDrawer.open();

          } else {

            cartDrawer.classList.add(
              'active'
            );

            cartDrawer.setAttribute(
              'open',
              ''
            );

          }

        }

      }


      /*
       * ===================================================
       * CART ICON
       * ===================================================
       */

      const cartIcon =
        document.querySelector(
          '#cart-icon-bubble'
        );


      if (
        cartIcon &&
        sections['cart-icon-bubble']
      ) {


        const parser =
          new DOMParser();


        const newIcon =
          parser.parseFromString(

            sections[
              'cart-icon-bubble'
            ],

            'text/html'

          ).querySelector(
            '#cart-icon-bubble'
          );


        if (newIcon) {

          cartIcon.innerHTML =
            newIcon.innerHTML;

        }

      }


      /*
       * ===================================================
       * LOAD RECOMMENDATIONS AGAIN
       * ===================================================
       */

      await wait(100);


      recommendationLoading =
        false;


      await loadCartDrawerRecommendations();


    } catch (error) {


      console.error(
        '[Cart Recommendations] Drawer ERROR:',
        error
      );


      recommendationLoading =
        false;

    }

  }


  /*
   * =======================================================
   * RECOMMENDATION SLIDER
   * =======================================================
   */

  function initializeRecommendationSlider() {


    const slider =
      document.querySelector(
        '.cart-recommendation-slider'
      );


    if (!slider) {

      return;

    }


    const nextButton =
      document.querySelector(
        '.cart-rec-next'
      );


    const prevButton =
      document.querySelector(
        '.cart-rec-prev'
      );


    if (nextButton) {

      nextButton.onclick =
        function () {

          slider.scrollBy({

            left:
              slider.clientWidth * 0.8,

            behavior:
              'smooth'

          });

        };

    }


    if (prevButton) {

      prevButton.onclick =
        function () {

          slider.scrollBy({

            left:
              -slider.clientWidth * 0.8,

            behavior:
              'smooth'

          });

        };

    }

  }


  /*
   * =======================================================
   * RECOMMENDATION ADD BUTTON CLICK
   * =======================================================
   */

  document.addEventListener(
    'click',
    function (event) {


      const button =
        event.target.closest(
          '.cart-recommendation-add'
        );


      if (!button) {

        return;

      }


      event.preventDefault();


      const variantId =
        button.dataset.variantId;


      if (!variantId) {

        return;

      }


      addRecommendationToCart(
        button,
        variantId
      );

    }
  );


  /*
   * =======================================================
   * FORMAT MONEY
   * =======================================================
   */

  function formatMoney(cents) {


    const currency =

      window.Shopify.currency &&
      window.Shopify.currency.active

        ? window.Shopify.currency.active

        : 'INR';


    try {

      return new Intl.NumberFormat(

        document.documentElement.lang ||
        'en-IN',

        {

          style:
            'currency',

          currency:
            currency

        }

      ).format(

        Number(cents) / 100

      );


    } catch (error) {

      return (

        '₹' +

        (
          Number(cents) / 100
        ).toFixed(2)

      );

    }

  }


  /*
   * =======================================================
   * ESCAPE HTML
   * =======================================================
   */

  function escapeHTML(value) {


    const div =
      document.createElement(
        'div'
      );


    div.textContent =
      value || '';


    return div.innerHTML;

  }


  /*
   * =======================================================
   * WAIT
   * =======================================================
   */

  function wait(milliseconds) {

    return new Promise(
      function (resolve) {

        setTimeout(
          resolve,
          milliseconds
        );

      }
    );

  }


  /*
   * =======================================================
   * EXPOSE RECOMMENDATION FUNCTION
   * =======================================================
   */

  window.loadCartDrawerRecommendations =
    loadCartDrawerRecommendations;


  window.refreshCartDrawer =
    refreshCartDrawer;


  /*
   * =======================================================
   * INITIAL RECOMMENDATIONS
   * =======================================================
   *
   * This handles:
   * - page load
   * - drawer already present
   *
   * =======================================================
   */

  setTimeout(
    function () {

      loadCartDrawerRecommendations();

    },
    300
  );


  /*
   * =======================================================
   * CART DRAWER BACKDROP CLOSE
   * =======================================================
   */

  document.addEventListener(
    'click',
    function (event) {


      const drawer =
        event.target.closest(
          'cart-drawer'
        );


      if (!drawer) {

        return;

      }


      /*
       * Click inside drawer = do nothing
       */

      if (
        event.target.closest(
          '.drawer__inner'
        )
      ) {

        return;

      }


      /*
       * Click backdrop = close
       */

      if (
        typeof drawer.close ===
        'function'
      ) {

        drawer.close();

      }

    }
  );


});